import styled from 'styled-components';

export const StyledMusicPlayerRow = styled.div`
  width: 100%;
  height: 100px;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
`;
